import { message } from 'antd' 
const handleAxiosStatus = (status, msg) =>{
    if(status == 401) return window.location.href = "/"
    if(status == 403) return message.error(msg)
    return message.error('Unknown Error')
}


const exports = {
    handleAxiosStatus
}

export default exports